//import { combineReducers } from 'redux';
import { createReducer, getType } from 'typesafe-actions';

import { userLoggedIn, userLoginFail } from '../actions/auth.actions';
import { authInit } from '../dtos/auth.dtos';

const authReducer = createReducer(authInit)
  .handleType(getType(userLoggedIn), (state, action) => action.payload)
  .handleType(getType(userLoginFail), (state, action) => action.payload);

export default authReducer;